import * as React from "react"

const FryUnclear = (props: React.SVGProps<SVGSVGElement>) => (
	<svg
		{...props}
		width="112"
		height="100"
		viewBox="0 0 112 100"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<path
			d="M58.2234 30.4357C58.3098 29.6952 57.9975 29.0502 57.5257 28.9951C57.054 28.94 56.6014 29.4957 56.515 30.2363C56.4285 30.9768 56.7408 31.6218 57.2126 31.6769C57.6844 31.732 58.1369 31.1763 58.2234 30.4357Z"
			fill="#2A2D33"
		/>
		<path
			d="M50.9431 30.3417C51.0341 29.5627 50.7031 28.884 50.2039 28.8257C49.7048 28.7674 49.2263 29.3516 49.1354 30.1306C49.0444 30.9095 49.3754 31.5883 49.8746 31.6466C50.3738 31.7048 50.8522 31.1206 50.9431 30.3417Z"
			fill="#2A2D33"
		/>
		<path
			d="M23.1204 21.0908C13.1804 26.2608 5.67035 35.3308 2.50034 46.1508C1.12033 50.8108 0.560328 55.8108 0.95033 60.9408C1.52033 68.6008 4.16034 75.6408 8.27036 81.4908C16.3504 93.1308 30.2104 100.261 45.3805 99.1308C47.6305 98.9608 49.8305 98.6208 51.9605 98.0908C53.3605 97.7508 54.7105 97.3508 56.0505 96.8808C59.6906 95.6008 63.1106 93.8008 66.1806 91.6008C67.6906 90.5208 69.1006 89.3508 70.4406 88.1108H70.4606L70.6106 87.9608"
			stroke="#2A2D33"
			strokeWidth="1.5"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
		<path
			d="M64 25.4209C67.55 27.5109 70.77 30.1609 73.57 33.2309C78.3801 38.5109 81.8901 45.1509 83.4401 52.6809C83.6701 53.8109 83.8601 54.9409 83.9901 56.0809"
			stroke="#2A2D33"
			strokeWidth="1.5"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
		<path
			d="M51.4902 53.1009C53.9102 52.2509 55.9803 50.5909 57.1303 48.2909C58.3603 45.8209 58.4503 42.9909 58.7003 40.2109"
			stroke="#2A2D33"
			strokeWidth="1.5"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
		<path
			d="M35.93 42.0107C34.19 41.3707 32.76 39.8407 32.44 38.0307C32.12 36.2207 33.04 34.1807 34.72 33.3907C36.4 32.6207 38.68 33.3107 39.47 34.9707C41.38 31.8607 41.02 27.5607 38.7 24.7407C39.4 25.3107 40.62 25.1707 41.28 24.4607C42 23.6707 42.03 22.4007 41.66 21.3807C41.29 20.3607 40.55 19.5307 39.85 18.7207C41.04 20.1007 45.26 20.6407 47.02 20.9807C49.57 21.4507 52.17 22.0407 54.79 21.9807C57.8301 21.9207 59.7501 20.8707 59.7501 20.8707C61.5201 23.0207 61.1701 27.1007 60.8801 28.9607C60.5401 31.1707 59.9001 33.3207 59.3901 35.4907"
			stroke="#2A2D33"
			strokeWidth="1.5"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
		<path
			d="M55.0605 40.0219C56.1006 40.8219 57.6006 40.8619 58.7006 40.2219C58.8806 40.1219 59.0306 39.9919 59.1906 39.8519C60.2906 38.8119 60.4606 36.9519 59.6006 35.7419C59.5406 35.6619 59.4806 35.5819 59.4006 35.5119C58.6006 34.5319 57.2706 34.0819 56.0105 33.7119"
			stroke="#2A2D33"
			strokeWidth="1.5"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
		<path
			d="M59.7805 20.9506C61.2505 20.3206 62.2105 18.8206 62.5206 17.2506C62.8306 15.6806 62.5706 14.0606 62.1605 12.5206C60.9605 8.05061 58.4405 3.95061 55.0005 0.870605C55.1105 2.95061 54.0005 5.04061 52.2305 6.13061C51.5405 3.74061 49.2405 1.90061 46.7605 1.75061C47.9005 3.12061 47.5905 5.20061 46.8205 6.80061C46.3505 7.78061 45.6905 8.73061 44.7205 9.22061C43.2605 9.96061 41.5105 9.50061 39.8705 9.49061C36.0904 9.48061 32.4804 12.3106 31.6104 15.9906C31.6304 15.2906 31.6404 14.5306 31.2604 13.9406C30.8804 13.3506 29.9704 13.0406 29.4604 13.5306C29.2004 13.7806 29.1104 14.1706 29.0804 14.5306C28.9804 15.5706 29.1904 16.6406 29.6704 17.5706C28.8304 16.4906 27.4904 15.3906 26.2504 15.9606C25.1704 16.4606 24.9804 18.0106 25.5504 19.0506C26.1204 20.0906 27.2004 20.7306 28.2204 21.3306C26.1604 26.5506 27.9504 33.0406 32.4104 36.4506"
			stroke="#2A2D33"
			strokeWidth="1.5"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
		<path
			d="M35.93 42C35.91 44.69 35.19 48.11 34.21 50.61"
			stroke="#2A2D33"
			strokeWidth="1.5"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
		<path
			d="M43.9404 55.381C45.9804 59.181 47.2604 63.381 47.6804 67.681C47.7004 67.601 53.1205 58.921 55.4305 54.441C54.6105 53.811 53.7805 53.181 52.9605 52.541"
			stroke="#2A2D33"
			strokeWidth="1.5"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
		<path
			d="M35.28 46.5524C34.35 46.5224 33.42 46.5824 32.5 46.7424C31.86 46.8524 31.12 47.1024 30.97 47.7324C30.82 48.3824 31.41 48.9524 31.94 49.3524C35.51 52.0024 39.67 53.9324 43.8801 55.3524"
			stroke="#2A2D33"
			strokeWidth="1.5"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
		<path
			d="M51.7305 61.1297C53.1305 61.5597 54.4305 62.3097 55.5105 63.2997C55.7805 60.4097 55.6005 57.3297 55.4305 54.4297"
			stroke="#2A2D33"
			strokeWidth="1.5"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
		<path
			d="M43.8807 55.8404C43.1706 58.8004 42.9806 61.8804 43.3506 64.9004C40.6706 64.0504 38.0106 63.0604 35.5506 61.6904C33.0906 60.3204 30.8206 58.5704 29.0706 56.3604C28.6906 55.8804 28.3306 55.3704 28.1806 54.7704C28.0506 54.2504 28.0806 53.7004 28.1606 53.1704C28.4706 50.9404 29.6106 49.1404 31.0906 47.4404"
			stroke="#2A2D33"
			strokeWidth="1.5"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
		<path
			d="M1.36035 64.5212C7.74038 56.3512 18.0204 51.2612 28.4205 51.5212"
			stroke="#2A2D33"
			strokeWidth="1.5"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
		<path
			d="M91.9307 71.082C90.5407 73.992 84.8607 80.792 80.8006 84.652C78.6706 86.672 75.5406 87.212 72.8506 86.042L58.6506 79.832C58.7006 85.112 57.4406 91.822 56.0605 96.892"
			stroke="#2A2D33"
			strokeWidth="1.5"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
		<path
			d="M55.8301 55.8613C61.4901 56.3713 68.6001 60.5613 75.9902 65.4913C76.5702 65.8813 77.3302 65.8513 77.8802 65.4313L86.1302 59.0813"
			stroke="#2A2D33"
			strokeWidth="1.5"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
		<path
			d="M9.63019 83.3216C9.50019 78.7716 10.1202 74.2116 11.4802 69.8516"
			stroke="#2A2D33"
			strokeWidth="1.5"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
		<path
			d="M46.5403 44.1604C46.2403 44.4604 46.0403 44.6904 45.9203 45.0804C45.7103 45.7504 46.2603 46.2404 46.6703 46.3504C47.0103 46.4404 47.6103 46.3504 47.9403 46.2204C48.6903 45.9304 49.5703 45.5604 50.3803 45.6304C51.6703 45.7304 53.4003 46.5404 54.4903 45.4504C55.1503 44.7804 55.1203 43.9704 54.6803 43.2604C52.9803 40.5004 48.2503 42.4504 46.5403 44.1604Z"
			stroke="#2A2D33"
			strokeWidth="1.5"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
		<path
			d="M51.6496 25.1504C50.0996 25.3604 48.6296 26.1504 47.5996 27.3304"
			stroke="#2A2D33"
			strokeWidth="1.5"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
		<path
			d="M60.8506 28.0507C60.1906 26.8807 59.1306 25.9407 57.8906 25.4307"
			stroke="#2A2D33"
			strokeWidth="1.5"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
		<path
			d="M86.1309 59.0908C86.1309 62.5208 90.2409 70.3608 91.9209 71.0908"
			stroke="#2A2D33"
			strokeWidth="1.5"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
		<path
			d="M93.75 66.3008C94.7 66.1708 96.21 66.2408 97.48 65.3108C98.75 64.3808 99.52 63.3108 99.31 60.9608C100.48 61.0508 101.67 61.1308 102.82 60.8808C103.97 60.6308 105.09 59.9908 105.64 58.9508C106.19 57.9108 106.01 56.4608 105.05 55.7808C106.33 55.3408 106.6 54.1408 106.44 53.2708C106.22 52.0508 105.36 51.2608 104.12 51.1608C102.88 51.0608 101.13 51.5408 99.99 52.0408"
			stroke="#2A2D33"
			strokeWidth="1.5"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
		<path
			d="M92.1304 62.5313C93.6104 62.9913 95.1304 61.9613 96.1804 60.8213C97.2304 59.6813 98.1804 58.3213 99.6404 57.8013C100.48 57.5013 101.4 57.5213 102.26 57.2813C103.12 57.0413 103.99 56.4113 104.03 55.5213C104.08 54.4413 102.89 53.7013 101.81 53.6313C100.73 53.5613 99.6604 53.8913 98.5904 53.8113C100.07 51.3913 102.67 49.6913 105.48 49.3213C106.65 49.1613 107.9 49.2113 108.92 48.6313C109.94 48.0513 110.53 46.4913 109.66 45.6913C109.22 45.2813 108.56 45.2213 107.96 45.2113C101.01 45.0513 93.3404 47.9613 89.5604 53.8013C88.0504 56.1313 86.9104 59.0913 86.6104 61.7413"
			stroke="#2A2D33"
			strokeWidth="1.5"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
		<path
			d="M99.7006 60.9908C98.9306 61.0208 98.6006 60.2108 98.4906 59.6908C98.3806 59.1708 98.4606 58.3808 99.0206 58.0908"
			stroke="#2A2D33"
			strokeWidth="1.5"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
		<path
			d="M105.321 55.7806C104.921 55.7406 104.511 55.7606 104.141 55.8006"
			stroke="#2A2D33"
			strokeWidth="1.5"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
		<path
			d="M93.7505 66.3008C93.0905 67.7308 92.1605 69.0408 91.0205 70.1308"
			stroke="#2A2D33"
			strokeWidth="1.5"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
		<path
			d="M51.4901 53.1006C49.8801 53.5906 48.2601 53.6006 46.6201 53.1906"
			stroke="#2A2D33"
			strokeWidth="1.5"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
		<path
			d="M51.4908 53.1006L50.0508 59.6106"
			stroke="#2A2D33"
			strokeWidth="1.5"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
	</svg>
)

export default FryUnclear
